<script>
import { createEventDispatcher } from 'svelte'
const dispatch = createEventDispatcher();

export let groupName = '';

const navigate = (page) => () => {
    dispatch('navigate', page);
}

</script>

<article class="card">
    <h1><small>Welcome to</small><br><big>Laments</big><br>
    {#if groupName}
        <small>for {groupName}</small>
    {/if}
    </h1>
    <p>Welcome to <i>Laments</i>. You can choose to receive a lament submitted by someone else, or to lift up a lament of your own.</p>
    <button class="pure-button button-round" on:click="{navigate('submit')}" >Lift up</button>
    <button class="pure-button button-round" on:click="{navigate('receive')}" >Receive</button>
</article>

